import { Component, inject } from '@angular/core';
import { EnvironmentService } from '@web/service';
import { FooterAdditionalInfoComponent } from './additional-info/footer-additional-info.component';
import { FooterNeedHelpComponent } from './need-help/footer-need-help.component';

@Component({
  selector: 'cas-footer',
  template: `
    <div class="d-flex flex-column">
      <div
        class="d-flex footer-bg justify-content-center py-6 px-4 px-xxl-0 text-ink-white"
        [style.background]="footer.bgImage ? 'url(' + footer.bgImage + ')' : 'var(--bs-primary)'">
        <div class="footer-content row gx-6 mx-0">
          <cas-footer-need-help class="col" />
        </div>
      </div>
      <div class="d-flex justify-content-center px-4 px-xxl-0 bg-white">
        <div class="d-flex footer-content">
          <cas-footer-additional-info class="w-100" />
        </div>
      </div>
    </div>
  `,
  styles: `
    .footer-bg {
      background-size: cover !important;

      @media (max-width: 768px) {
        background-position-x: right !important;
      }
    }

    .footer-content {
      max-width: 1160px;
      width: 100%;

      @media (width <= 1400px) {
        max-width: 696px;
      }

      @media (width <= 768px) {
        max-width: 100%;
      }
    }

    cas-footer-need-help {
      @media (width >= 768px) {
        min-width: 50%;
      }
    }
  `,
  imports: [FooterNeedHelpComponent, FooterAdditionalInfoComponent],
})
export class FooterComponent {
  private environment = inject(EnvironmentService);

  footer = this.environment.environment.footer;
}
